import { render } from "./demandService.vue?vue&type=template&id=e56cb2da&scoped=true"
import script from "./demandService.vue?vue&type=script&lang=js"
export * from "./demandService.vue?vue&type=script&lang=js"

import "./demandService.vue?vue&type=style&index=0&id=e56cb2da&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-e56cb2da"

export default script